var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 2.54289e-07C12.4112 6.39933e-07 16 3.58877 16 8C16 12.4112 12.4113 16 8.00003 16C3.58879 16 -1.59361e-06 12.4112 -1.20797e-06 8C-8.22325e-07 3.58877 3.58879 -1.31348e-07 7.99997 2.54289e-07ZM7.99997 14.0435C11.3324 14.0435 14.0435 11.3324 14.0435 8C14.0435 4.6676 11.3324 1.95652 7.99997 1.95652C4.66755 1.95652 1.95646 4.6676 1.95646 8C1.95646 11.3324 4.66761 14.0435 7.99997 14.0435Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02157 7.12031L8.9781 7.12031L8.9781 12.2725L7.02157 12.2725L7.02157 7.12031Z",
    fill: "#171717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0217 3.72827L8.97823 3.72827L8.97823 5.61957L7.0217 5.61957L7.0217 3.72827Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/Vector-Icon.bad4c230c51f34ae1c96d71d237b9dfb.svg";
export { ForwardRef as ReactComponent };